// @flow
import OrgsMenuPage, { dataKey } from './OrgsMenuPage';

export default OrgsMenuPage;
export { dataKey };
